var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-btn mx-md text-lg md:hidden cursor-pointer w-lg",on:{"click":_vm.toggle}},[(! _vm.shown)?_c('font-awesome-icon',{attrs:{"icon":"bars"}}):_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }